/* Publish by EComposer at 2026-10-16 18:17:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-646xrkbvqg3"]=  window.__ectimmers["ecom-646xrkbvqg3"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-646xrkbvqg3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-646xrkbvqg3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcomaxbg50h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcomaxbg50h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3vyxmjl1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3vyxmjl1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tj0ze1561w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tj0ze1561w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lex2bwmg2df').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lex2bwmg2df', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x8l4taf32ub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x8l4taf32ub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ln8gsq1oj5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ln8gsq1oj5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cxkz6n5jij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cxkz6n5jij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95pdo4ceak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95pdo4ceak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hc0cn4235ho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hc0cn4235ho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nskc4gzwaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nskc4gzwaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28aivbky81ij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28aivbky81ij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1bz79lyywp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1bz79lyywp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsty6hct135').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsty6hct135', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nuc37wgtc4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nuc37wgtc4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dg1df1yp748').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dg1df1yp748', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-safrx9t2qwn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-safrx9t2qwn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1z9la415h06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1z9la415h06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vnu5ch0enk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnu5ch0enk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtoobep5e1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtoobep5e1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5kzbctqcy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5kzbctqcy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twe6ixjdwcl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twe6ixjdwcl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nl137k1orf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nl137k1orf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wf1wmvq33d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wf1wmvq33d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cxzpcn9h7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxzpcn9h7f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77xt4a9vmia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77xt4a9vmia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ao8443bexjg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ao8443bexjg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1mms1pxjjia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mms1pxjjia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2hnyfjik1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2hnyfjik1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouhsdsh4h8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouhsdsh4h8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uvpnh3yn2km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uvpnh3yn2km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znyxu6bz6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znyxu6bz6d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fay5pfka6mk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fay5pfka6mk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozkfi1oonv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozkfi1oonv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n591sz39dk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n591sz39dk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tj9vbwt23w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tj9vbwt23w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph40wxu9q2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph40wxu9q2n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zee0prj0xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zee0prj0xo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lgg945hwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lgg945hwp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8jrfh3tpxj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8jrfh3tpxj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkmqpeq41ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkmqpeq41ff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvt6ps0xzsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvt6ps0xzsd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xo9hog33sal"]=  window.__ectimmers["ecom-xo9hog33sal"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-xo9hog33sal"]["aawliwt7k"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-xo9hog33sal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xo9hog33sal', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6txt8njgyr5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6txt8njgyr5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7z8iojae7qi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7z8iojae7qi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwuxyb64f8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwuxyb64f8q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hotdfxzgah4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hotdfxzgah4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tsj8n70eqio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsj8n70eqio', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vl1y9fw9h5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vl1y9fw9h5i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pagims9p2q8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pagims9p2q8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-evq5a9v5faj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-evq5a9v5faj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zw66jn0cvj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zw66jn0cvj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87jtfjcfys3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87jtfjcfys3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifmdclktq5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifmdclktq5l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3m2kw5f1bq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3m2kw5f1bq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bw03z74syue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bw03z74syue', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l46kuxw52').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l46kuxw52', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnbtm4s8a4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnbtm4s8a4h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09bqg8cx2y4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09bqg8cx2y4w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cx39rmw9p5a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cx39rmw9p5a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m53nwa6y54c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m53nwa6y54c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y67wexwownq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y67wexwownq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwplh4s3nah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwplh4s3nah', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nsolox9thko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nsolox9thko', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtwb2cxejfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtwb2cxejfm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpdwewruoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpdwewruoa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nruabr29ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nruabr29ff', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ixjgop96ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ixjgop96ug', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ci54l1n52um').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ci54l1n52um', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxq60o0midd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxq60o0midd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vs9sehm8n9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vs9sehm8n9d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amay8k32a6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amay8k32a6c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k72jw57h4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k72jw57h4c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c55i8n8dqae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c55i8n8dqae', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fg52jap0zp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fg52jap0zp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i9emxmad3p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i9emxmad3p9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rrch3jx64i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rrch3jx64i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8ja1okyv6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8ja1okyv6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bjas1u7nso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bjas1u7nso', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8730xnqoxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8730xnqoxr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hm8rz1oifk7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hm8rz1oifk7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yfssy2fs21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfssy2fs21', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jx0m16rll4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jx0m16rll4q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5joi0xlr2jn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5joi0xlr2jn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hh7foqsjm8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hh7foqsjm8t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ec5jpbfvm9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ec5jpbfvm9j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ev73ay8zf6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ev73ay8zf6m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zx38wul1iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zx38wul1iq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xk1674w1ql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xk1674w1ql', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1ax9i01by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1ax9i01by', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94fs315u5pp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94fs315u5pp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kozfli6tzhm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kozfli6tzhm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09ue1l0czmd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09ue1l0czmd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eh4rj8idyi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eh4rj8idyi8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjrdvsgawyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjrdvsgawyi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjr65qqlrut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjr65qqlrut', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-myu346hf34m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-myu346hf34m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uarwxhcmbsf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uarwxhcmbsf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cxmtehaawuu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxmtehaawuu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2ifwbtafz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2ifwbtafz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmopn1tq0if').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmopn1tq0if', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33mec9ogyu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33mec9ogyu7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-116cieo2xhx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-116cieo2xhx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y792ynq7nfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y792ynq7nfj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ko8iuyyeoce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ko8iuyyeoce', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93mrpomzfav').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93mrpomzfav', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-raq9juqxig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-raq9juqxig', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u28uxj6t2gp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u28uxj6t2gp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzpwwl0v00r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzpwwl0v00r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5k4zhljae83').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5k4zhljae83', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1eosrmlgb46h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1eosrmlgb46h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cnuzfp0jze6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cnuzfp0jze6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwatn3ej7ai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwatn3ej7ai', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35xnuebu9bi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35xnuebu9bi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kayp8h3v67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kayp8h3v67', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9kumdiez5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9kumdiez5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9iih0v259dv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9iih0v259dv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk204h6jna').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk204h6jna', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzh856z3kb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzh856z3kb8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x5xpun8c42').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x5xpun8c42', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7itv7khgzuu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7itv7khgzuu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clmcy6042g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clmcy6042g9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ysn0qzlb86d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ysn0qzlb86d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6w59ortyaar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6w59ortyaar', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2whxhayw9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2whxhayw9n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6ttohhu2ki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6ttohhu2ki', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-17w1yp958yz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-17w1yp958yz', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cophvbg2u9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cophvbg2u9l', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ek2v2mxofa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ek2v2mxofa', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x839srnf5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x839srnf5o', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ow5mox9p5st').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ow5mox9p5st', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}